import Icon from '../../marker/rectangle/Rectangle';
import WaterLevelStatusColor from './waterLevelStatusColor';

const WaterLevelColor1 = (wl) => {
  let color;
  let icon;
  let level;
  const wlIcon = Icon;
  const [zero, one, two, three, four, five] = WaterLevelStatusColor;

  if (wl === null) {
    color = zero;
    icon = wlIcon.grey;
    level = 0;
  } else if (wl > 100) {
    color = five;
    icon = wlIcon.red;
    level = 5;
  } else if (wl > 70) {
    color = four;
    icon = wlIcon.blue;
    level = 4;
  } else if (wl > 30) {
    color = three;
    icon = wlIcon.green;
    level = 3;
  } else if (wl > 10) {
    color = two;
    icon = wlIcon.yellow;
    level = 2;
  } else if (wl <= 10) {
    color = one;
    icon = wlIcon.orange;
    level = 1;
  } else {
    color = zero;
    icon = wlIcon.grey;
    level = 0;
  }

  return { color, icon, level };
};

export default WaterLevelColor1;
